import { FC, MouseEvent } from "react";
import FeatureTile from "./featureTile";
import { Stack, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useGetModel from "../hooks/getModel";
import Album from "../models/album";
import { formatDateUTC, formatDuration, formatNumber } from "../utils/formatUtils";
import { getPublicAlbumImageUrl } from "../utils/fileUtils";
import { useNavigate } from "react-router-dom";
//import useQuickFilterPortal from "../hooks/useQuickFilterPortal";

type Props = {
	width?: number | string;
	height?: number | string;
	fullWidth?: boolean;
}

const LatestAlbumFeatureTile: FC<Props> = ({ width, height, fullWidth }) => {
	const { data: albumData, loading } = useGetModel<Album>('/album', 'latest');
	const navigate = useNavigate();

	const handleClick = (event: MouseEvent) => {
		navigate({ pathname: '/tunes', search: `?q=${albumData?.name}` });
	};

	return (
		<>
			{albumData && !loading && (
				<FeatureTile
					width={fullWidth ? '100%' : width || 240}
					height={height || 240}
					imageUrl={getPublicAlbumImageUrl(albumData)}
					subtitle="Latest Album"
					title={albumData.name}
					caption={(
						<Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
							<Typography variant="caption">{formatDateUTC(albumData.releaseDate, 'MMM D, YYYY')}</Typography>
							<FontAwesomeIcon icon={['fas', 'circle']} style={{ fontSize: 6 }} />
							<Typography variant="caption">{formatNumber(albumData.totalSongs)} tunes</Typography>
							<FontAwesomeIcon icon={['fas', 'circle']} style={{ fontSize: 6 }} />
							<Typography variant="caption">{formatDuration(albumData.totalDuration)}</Typography>
						</Stack>
					)}
					onClick={handleClick}
				/>
			)}
		</>
	);
};

export default LatestAlbumFeatureTile;
